<template>
  <div class="site-section" id="home">
    <section class="hero is-medium is-black is-vcentered">
      <div class="columns">
        <div class="column is-one-third">
          <img src="../assets/guys.png">
        </div>
        <div class="column">
          <div class="hero-body">
            <p class="lucky-title is-size-1">we are the NFDaddys!</p>
            <p>NFDaddys are a family friendly learning center.  NFD Academy accelerates your journey into web3. You can be just starting out, a web2 expert looking to transition, or thinking about creating your "Y" in web3!  Building on your own is so web2, come join the incredible community at NFDaddys.</p>
            <p style="height: 50px; padding-top: 20px;">
              <a href="https://forms.gle/sJYTRfrucykLGvU2A" target="_blank">
                <button class="button is-large is-dark lucky-title is-responsive" style="padding-bottom: 12px !important">
                  Join us Now!
                </button>
              </a>
            </p>
          </div>
        </div>

      </div>
    </section>
    <div class="site-section" id="about">

      <div class="columns text-center m-5">
        <div class="column">
          <div class="card">
            <div class="card-image">
              <figure class="image">
                <a href="/token/mint"><img src="../assets/mint.png" alt="Mint"></a>
              </figure>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="card">
            <div class="card-image">
              <figure class="image">
                <a href="/nfd-academy/web3-workshops"><img src="../assets/education.png" alt="Education"></a>
              </figure>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="card">
            <div class="card-image">
              <figure class="image">
                <a href="/token/roadmap"><img src="../assets/road.png" alt="Road"></a>
              </figure>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="card">
            <div class="card-image">
              <figure class="image">
                <a href="https://discord.gg/4gQZYE9NC9" target="_blank"><img src="../assets/discord.png" alt="Discord"></a>
              </figure>
            </div>
          </div>
        </div>
      </div>

      <h1 class="is-size-1 lucky-title text-center has-text-white">
        This is what we do
      </h1>

      <div class="columns text-center m-5 has-text-left	">
        <div class="column">
          <a href="/nfd-academy/web3-workshops">
            <div class="card">
              <div class="card-image">
                <figure class="image">
                  <img src="../assets/class.png" alt="Education">
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-48x48">
                      <img src="../assets/class.png" alt="Education">
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4">Education</p>
                    <p class="subtitle is-6">Let's learn together!</p>
                  </div>
                </div>

              </div>
            </div>
          </a>
        </div>

        <div class="column">
          <a href="/utility">
            <div class="card">
              <div class="card-image">
                <figure class="image">
                  <img src="../assets/utility.png" alt="Utility">
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-48x48">
                      <img src="../assets/utility.png" alt="NFD Portal">
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4">NFD Portal</p>
                    <p class="subtitle is-6">Here comes utility!</p>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="column">
          <a href="/events/fathers-day-5k">
            <div class="card">
              <div class="card-image">
                <figure class="image">
                  <img src="../assets/beach.png" alt="NFD 5k">
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-48x48">
                      <img src="../assets/beach.png" alt="NFD 5k">
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4">Fathers Day 5k</p>
                    <p class="subtitle is-6">We made it to the beach!</p>
                  </div>
                </div>

              </div>
            </div>
          </a>
        </div>
      </div>

      <!-- <div class="text-center mt-5 mobile" style="display: none;">
        <img src="../assets/mobile/ready.gif" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
<style scoped>

.hero {
  /* background: linear-gradient(0deg, rgba(0,0,0,1) 17%, rgba(255,226,0,1) 49%, rgba(255,106,0,1) 100%); */
  background: linear-gradient(0deg, rgba(0,0,0,1) 3%, rgba(255,226,0,1) 33%, rgba(255,106,0,1) 100%);
  color: #000;
}
  .hero .lucky-title {
    line-height: 3rem !important;
  }

.hero button.button {
  padding-bottom: 2px !important;
  height: 2em !important;
}

</style>
<style>
@media (max-width: 820px) {

  #roadmap .overlay {
    font-size: 50px !important;
  }
}

@media (max-width: 470px) {

  #roadmap .overlay {
    font-size: 35px !important;
    transform: rotate( -15deg) translateX(-50%) translateY(0%);
  }
}

@media (max-width: 890px) {
  .radio-overlay {
    top: 46% !important;
    height: 9% !important;
    /* background: #f00 !important; */
  }
}

@media (max-width: 590px) {
  .radio-overlay {
    top: 44% !important;
    height: 8% !important;
    width: 12% !important;
    /* background: #00f !important; */
  }
}

/* ------------------------------------------------------- */
/* --------------------       PHONE       ---------------- */
/* ------------------------------------------------------- */

@media (max-width: 550px) {
  .mobile {
    display: block !important;
  }
  .desktop {
    display: none !important;
  }

  .mobile .song {
    padding-bottom: 20px;
  }
    .mobile .song a {
      color: #fff;
      text-decoration: none;
    }
}
</style>
<script>
/* eslint-disable no-console */
export default {
  name: "Home",
  mounted() {
      // window.addEventListener("load", this.initAudio);
  },
  methods: {
    initAudio() {

      window.myAudio = document.getElementById("myAudio");
      window.radioOverlay = document.getElementById("radio-overlay");
      console.log('%c loaded ', 'background-color: red; color: #000', window.myAudio, window.radioOverlay);

      window.radioOverlay.addEventListener("click", this.togglePlay);


    },
    togglePlay() {
      window.pauseButton = document.getElementById("radio-pause");
      if(window.myAudio.paused) {
        // window.pauseButton.style.display = 'block';
        window.myAudio.play()
      } else {
        // window.pauseButton.style.display = 'none';
        window.myAudio.pause()
      }
    }
  }
};
/* eslint-enable no-console */
</script>


<!--

<template>
  <div class="fully-center site-section" id="home">
    <img src="../assets/car-closed.png" usemap="#image-map" />
    <map name="image-map">
      <area alt="Security" title="Security" href="#" coords="895,468,1275,586" shape="rect">
      <area alt="Roadmap" title="Roadmap" href="#" coords="1208,825,1584,584" shape="rect">
    </map>
  </div>
</template>

<script>
export default {
  name: "Home",
  create() {
      window.addEventListener("load", this.initRollovers);
  },
  methods: {
    initRollovers() {
      /* eslint-disable no-console */
      console.log('%c loaded ', 'background-color: red; color: #000');
      /* eslint-enable no-console */
      //! stolen from stackoverflow; will rework
      var images = document.querySelectorAll('img[usemap]');
      images.forEach( function(image) {
          var mapid = image.getAttribute('usemap').substr(1);
          var imagewidth = image.getAttribute('width');
          var imageheight = image.getAttribute('height');
          var imagemap = document.querySelector('map[name="'+mapid+'"]');
          var areas = imagemap.querySelectorAll('area');

          image.removeAttribute('usemap');
          imagemap.remove();

          // create wrapper container
          var wrapper = document.createElement('div');
          wrapper.classList.add('imagemap');
          image.parentNode.insertBefore(wrapper, image);
          wrapper.appendChild(image);

          areas.forEach( function(area) {
              var coords = area.getAttribute('coords').split(',');
              var xcoords = [parseInt(coords[0]),parseInt(coords[2])];
              var ycoords = [parseInt(coords[1]),parseInt(coords[3])];
              xcoords = xcoords.sort(function(a, b){return a-b});
              ycoords = ycoords.sort(function(a, b){return a-b});
              wrapper.innerHTML += "<a href='"+area.getAttribute('href')+"' title='"+area.getAttribute('title')+"' class='area' style='left: "+((xcoords[0]/imagewidth)*100).toFixed(2)+"%; top: "+((ycoords[0]/imageheight)*100).toFixed(2)+"%; width: "+(((xcoords[1] - xcoords[0])/imagewidth)*100).toFixed(2)+"%; height: "+(((ycoords[1] - ycoords[0])/imageheight)*100).toFixed(2)+"%;'></a>";
          });
      });
    }
  }
};
</script>
<style scoped>
.site-section {
  background: #000000;
  color: #ffffff;
  padding: 0;
}

img {
  max-width: 100%;
  height: auto;
  padding-bottom: 50px;
}

.imagemap {position: relative;}
.imagemap img {display: block;}
.imagemap .area {display: block; position: absolute; transition: box-shadow 0.15s ease-in-out;}
.imagemap .area:hover {box-shadow: 0px 0px 1vw rgba(0,0,0,0.5);}
</style>

-->

<!--
  <div class="desktop" style="display: none;">
    <img src="../assets/car-closed-radio.png" id="car" usemap="#image-map" />
    <a href="/nft101" title="NFT 101" class="image-map-1"></a>
    <a href="https://discord.gg/4gQZYE9NC9" title="LFG" class="image-map-2" target="_blank"></a>
    <a href="#roadmap" title="Roadmap" class="image-map-3"></a>
    <a href="#" title="Play/Pause" class="radio-overlay" id="radio-overlay"></a>
    <a href="#" title="Play/Pause" class="radio-button" id="radio-pause"><img src="../assets/car-radio-pause.png" width="100%" /></a>
    <div class="radio-name">Dad Life Theme</div>
    <div class="radio">
      <audio controls src="../assets/dad-life.mp3" id="myAudio"></audio>
    </div>
  </div>
  <div class="mobile">
    <div class="logo"><img src="../assets/mobile/logo.png" alt="NFDaddys Logo" title="NFDaddys Logo" /></div>
    <div class="song">
      <figure>
          <figcaption>
            Dad Life by <a href="https://www.instagram.com/whatdidadamsay/" target="_blank">@whatdidadamsay</a>:
          </figcaption>
          <audio controls src="../assets/dad-life.mp3">
            Your browser does not support the <code>audio</code> element.
          </audio>
      </figure>
    </div>
    <div class="buttons">
      <ul>
        <li><a href="#faq"><img src="../assets/mobile/button-1.png" alt="Questions" title="Questions"></a></li>
        <li><a href="#roadmap"><img src="../assets/mobile/button-3.png" alt="Roadmap" title="Roadmap"></a></li>
        <li><a href="/nft101"><img src="../assets/mobile/button-2.png" alt="NFT 101" title="NFT 101"></a></li>
        <li><a href="/about"><img src="../assets/mobile/button-4.png" alt="Our 'Y'" title="Our 'Y'"></a></li>
        <li><a href="#team"><img src="../assets/mobile/button-5.png" alt="Contact" title="Contact"></a></li>
      </ul>
    </div>
    <div class="mint"><a href="/mint"><img src="../assets/mobile/button-mint.png" alt="Mint" title="Mint"></a></div>
    <div class="social">
      <img src="../assets/mobile/buttons-bar.png" />
      <a class="social-1" href="https://discord.gg/4gQZYE9NC9" target="_blank" alt="NFDaddys Discord" title="NFDaddys Discord"><img src="../assets/shim.png" /></a>
      <a class="social-2" href="https://twitter.com/nfdaddys" target="_blank" alt="NFDaddys Twitter" title="NFDaddys Twitter"><img src="../assets/shim.png" /></a>
      <a class="social-3" href="https://www.youtube.com/channel/UCrjqrXhi4iDjf-FqarQ75wg" target="_blank" alt="NFDaddys YouTube" title="NFDaddys YouTube"><img src="../assets/shim.png" /></a>
      <a class="social-4" href="https://vm.tiktok.com/ZMRo23m4c/" target="_blank" alt="NFDaddys TikTok" title="NFDaddys TikTok"><img src="../assets/shim.png" /></a>
    </div>
  </div>
-->